import { ENDPOINT } from '@old/data/core/endpoints';
import { BACKEND } from '@old/services/core/fetch-backend';

import { SilobagHistoryEventCategoriesData } from './silobag-history-event-categories.types';

// deprecated service ref.: getSilobagEventTypesService_DEPRECATED

// Implementado ✅
export async function silobagHistoryEventCategoriesService() {
  const { response, data } = await BACKEND.get<SilobagHistoryEventCategoriesData>(
    ENDPOINT.SILOBAG_EVENT_TYPES
  );

  return {
    response,
    summary: data,
  };
}
